  <div
    class="flex justify-content-between flex-wrap store-operation-hours-header pl-5 pr-5 pt-6"
  >
    <h1>Edit Operation Hours</h1>
    <button mat-icon-button mat-dialog-close class="close-button">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div mat-dialog-content class="dialog-content">
    <div class="section">
      <h3 class="section-title">Select Operating Days</h3>

      <div class="days-container">
        <button
          *ngFor="let day of weekDays; let i = index"
          mat-stroked-button
          class="day-button"
          [class.selected]="day.selected"
          [class.already-used]="isDayAlreadyUsed(day.name)"
          [disabled]="isDayAlreadyUsed(day.name) && !day.selected"
          [title]="isDayAlreadyUsed(day.name) ? 'This day is already used in another operation hours entry' : ''"
          (click)="toggleDay(i)"
        >
          {{ day.name }}
          <mat-icon *ngIf="isDayAlreadyUsed(day.name)" class="conflict-icon">warning</mat-icon>
        </button>
      </div>
    </div>

    <h3 class="section-title">Edit Store Hours</h3>

    <div
      *ngFor="let timeRange of timeRanges; let i = index"
      class="flex justify-content-start flex-wrap gap-3 align-items-center mt-4"
    >
      <!-- Start Time -->
      <div class="time-group">
        <mat-form-field
          appearance="outline"
          class="time-formfield"
          subscriptSizing="dynamic"
        >
          <mat-label>Start Time</mat-label>
          <mat-select
            [(ngModel)]="timeRange.startTime"
            (selectionChange)="onStartTimeChange(i)"
          >
            <mat-option *ngFor="let time of getStartTimeOptions(i)" [value]="time.value">
              {{ time.display }}
            </mat-option>
          </mat-select>
          <mat-icon matSuffix>schedule</mat-icon>
        </mat-form-field>
      </div>

      <!-- Separator -->
      <div class="time-separator">-</div>

      <!-- End Time -->
      <div class="time-group">
        <mat-form-field
          appearance="outline"
          class="time-formfield"
          subscriptSizing="dynamic"
        >
          <mat-label>End Time</mat-label>
          <mat-select
            [(ngModel)]="timeRange.endTime"
            (selectionChange)="onEndTimeChange(i)"
            [disabled]="!timeRange.startTime"
          >
            <mat-option *ngFor="let time of getEndTimeOptions(timeRange)" [value]="time.value">
              {{ time.display }}
            </mat-option>
          </mat-select>
          <mat-icon matSuffix>schedule</mat-icon>
        </mat-form-field>
      </div>

      <!-- Remove Time -->
      <button
        *ngIf="i !== timeRanges.length - 1"
        mat-mini-fab
        color="warn"
        (click)="removeTimeRange(i)"
      >
        <mat-icon>remove</mat-icon>
      </button>
      <!-- Add Button -->
      <button
        *ngIf="i === timeRanges.length - 1"
        mat-mini-fab
        color="primary"
        (click)="addTimeRange()"
      >
        <mat-icon>add</mat-icon>
      </button>

      <!-- Validation Error Messages -->
      <div *ngIf="timeRange.startTime && timeRange.endTime && !isValidTimeRange(timeRange)" 
           class="error-message mt-2">
        <mat-icon color="warn" class="error-icon">error</mat-icon>
        <span>End time must be after start time</span>
      </div>
    </div>

    <!-- Time Overlap Warning -->
    <div *ngIf="wouldCreateTimeOverlap()" class="error-message mt-3">
      <mat-icon color="warn" class="error-icon">warning</mat-icon>
      <span>Selected time ranges conflict with existing operation hours for the selected days</span>
    </div>

    <!-- Internal Time Overlap Warning -->
    <div *ngIf="hasInternalTimeOverlaps()" class="error-message mt-3">
      <mat-icon color="warn" class="error-icon">error</mat-icon>
      <span>Time ranges cannot overlap with each other</span>
    </div>
  </div>

  <mat-dialog-actions align="end" class="dialog-actions">
    <button mat-button mat-dialog-close color="warn">Discard</button>
    <button 
      mat-flat-button 
      color="primary" 
      (click)="save()"
      [disabled]="!hasSelectedDays || wouldCreateTimeOverlap() || hasInternalTimeOverlaps()"
      [title]="!hasSelectedDays ? 'Please select at least one operating day' : wouldCreateTimeOverlap() ? 'Cannot save due to conflicting schedules' : hasInternalTimeOverlaps() ? 'Cannot save due to overlapping time ranges' : ''">
      Update
    </button>
  </mat-dialog-actions>
